var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
import { Vector2dSchema } from "./utils/vector.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let RigidPolygonSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "bodyId");
    __publicField(this, "vertices");
    __publicField(this, "vertexOffsets");
    __publicField(this, "vertexIndicies");
    __publicField(this, "width");
    __publicField(this, "height");
  }
};
__decorateClass([
  type("number")
], RigidPolygonSchema.prototype, "bodyId", 2);
__decorateClass([
  type([Vector2dSchema])
], RigidPolygonSchema.prototype, "vertices", 2);
__decorateClass([
  type([Vector2dSchema])
], RigidPolygonSchema.prototype, "vertexOffsets", 2);
__decorateClass([
  type(["number"]),
  defaultValue([])
], RigidPolygonSchema.prototype, "vertexIndicies", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidPolygonSchema.prototype, "width", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], RigidPolygonSchema.prototype, "height", 2);
RigidPolygonSchema = __decorateClass([
  Component("RigidPolygon")
], RigidPolygonSchema);
const __vite_glob_0_23 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RigidPolygonSchema() {
    return RigidPolygonSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  RigidPolygonSchema as R,
  __vite_glob_0_23 as _
};
//# sourceMappingURL=RigidPolygon-b7405623.js.map
